import { render } from "./KanbanTask.vue?vue&type=template&id=787cdda3"
import script from "./KanbanTask.vue?vue&type=script&lang=js"
export * from "./KanbanTask.vue?vue&type=script&lang=js"

import "./KanbanTask.vue?vue&type=style&index=0&id=787cdda3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__